
define({
  inviteContent: '{name} invites you to study together in ClassIn',
  invalidContent: 'This QR code / link is invalid and cannot be recognized',
  download: 'Download ClassIn',
  clickOpen: 'Have installed the app? Click here to open it',
  browserWin: 'This URL cannot be opened in WeChat. Please copy it and open it in the browser.',
  QRcodeInvalid: 'This QR code / link is invalid and cannot be recognized',
  downloadImg: {
    scanCode: 'Scan QR code to add me as a friend',
    save: 'Press and hold to save image',
  },
  noAppTip: 'Please download and install ClassIn first',
  shareInfo: { title: '{name} invites you to study together in ClassIn' },
})
